<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
    <v-dialog max-width="400" v-model="primaryDialog">
      <v-card>
        <v-card-title
          ><h4>{{ $t("frequent_languages") }}</h4>
          <v-spacer />
          </v-card-title
        >
        <v-card-subtitle>{{ $t("choose5") }}</v-card-subtitle>
        <!-- <v-alert
          dense
          class="mx-5"
          border="right"
          colored-border
          type="error"
          :value="langAlert"
        >
          Language already exists
        </v-alert> -->
        
        <v-autocomplete
          autofocus
          ref="primary"
          :items="languageList"
          class="mx-5"
          v-model="languages"
          multiple
          chips
          allow-overflow
          deletable-chips
          :rules="rules"
          @input="searchInput = null"
          :search-input.sync="searchInput"
          solo
          auto-select-first
        ></v-autocomplete>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  color="primary lighten-1" @click="setPrimaryLanguages()">
            confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog width="300" v-model="templateLimitExceed" scrollable @click:outside="templateLimitExceed=false">
      <v-card height="250">
        <p class="text-center text-h5 mt-5 " >{{$t('upgrade_premium')}}</p >
        <v-card-text class="text-center">{{$t('premium_text')}}
        </v-card-text>
      <v-layout justify-center
        ><v-btn
          color="grey darken-3 white--text"
          tile
          @click="getPremium()"
          class="my-3"
        >
          <v-icon color="#FFD700">mdi-crown</v-icon>{{$t('get_premium')}}</v-btn
        ></v-layout
      >
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="getTransactionSuccess"
      width="400px"
      persistent
      scrollable
    >
      <v-card height="auto">
        <div justify-center class="text-h5 pt-5 text-center">
          {{ $t("upgrade_success") }}
        </div >
        <p class="text-center">
          <v-icon x-large class="pt-2 green--text">mdi-check-decagram</v-icon>
        </p>
        <v-card-text class="text-center">{{$t('success_premium')}}</v-card-text>
        <p class="text-center">
          <v-btn class="primary--text" text @click="closeSuccessDialog">{{
            $t("close")
          }}</v-btn>
        </p>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="getTransactionFailure"
      width="400px"
      persistent
      scrollable
    >
      <v-card height="auto">
        <div class="text-h5 pt-5 text-center">{{ $t("txn_failed") }}</div>
        <v-card-text class="text-center"
          >{{ $t("txn_error") }}
        </v-card-text>
        <p class="text-center">
          <v-icon x-large class="pt-2 red--text">mdi-alert-circle</v-icon>
        </p>
        <p class="text-center">
          <v-btn class="primary--text" text @click="closeFailureDialog">{{
            $t("close")
          }}</v-btn>
        </p>
      </v-card>
    </v-dialog>
    <v-overlay :value="getLoader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>
<script>
import { db } from "../firebaseconfig";
import { SplashScreen } from '@capacitor/splash-screen';
import {
  AdMob,
  BannerAdSize,
  BannerAdPosition,
  BannerAdPluginEvents,
} from "@capacitor-community/admob";
import { platform } from "../src/plugins/capacitorPlugin.js";

import { mapGetters ,mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      languageList: [],
      languages: [],
      searchInput: null,
      BannerAdLoaded: false,
      subscription:'',
      templateLimitExceed:false
    };
  },
  computed: {
    ...mapGetters({
      languages1: "getPrimaryLanguages",
      dictionary: "getDictionary",
      premium:'getPremium',
      getTransactionSuccess:'getTransactionSuccess',
      getTransactionFailure:"getTransactionFailure",
      getLoader:'getLoader'

    }),
    primaryDialog: {
      get() {
        return this.$store.getters.getPrimaryDialog;
      },
      set() {
        this.$store.commit("togglePrimaryDialog", false);
      },
    },
    rules() {
      const rules = [];
      if (this.languages) {
        const rule = (v) => (v || "").length > 0 || this.$t("min1");

        rules.push(rule);
      }
      if (this.languages) {
        const rule = (v) => (v || "").length < 11 || this.$t("max10");

        rules.push(rule);
      }
      return rules;
    },
    user() {
      return this.$store.getters.getUser;
    },
  },
  watch: {
    languages1(v) {
      this.languages = v;
    },
        subscription(val){
      if(val){
        if(val.type===1){
          this.$store.commit('setPremium',true)
        }else{
          this.$store.commit('setPremium',false)
        }
     }
    },
    $route(val) {
      if(!this.BannerAdLoaded && val.name==='settings'){
        this.showBannerAd();
      }
      if (this.BannerAdLoaded) {
        if (val.name !== "settings") {
          AdMob.hideBanner();
        } else if(!this.premium){
          AdMob.resumeBanner();
        }
      }
    },
 
  },
  methods: {
     ...mapActions([
      'getPremium'
    ]),
    ...mapMutations(['setOnlineStatus']),
    closeSuccessDialog() {
      this.$store.commit("setTransactionSuccess", false);
      // this.$router.go(-1);
      location.reload();
    },
     closeFailureDialog() {
      this.$store.commit("setTransactionFailure", false);
      location.reload();
    },
    async initAnalytics() {
                if (platform === "web") {
        this.$store.dispatch("initAnalytics");
      }
    },
    async showBannerAd() {
      if(!this.premium){
      AdMob.addListener(BannerAdPluginEvents.Loaded, () => {
        // Subscribe Banner Event Listener
      });

      AdMob.addListener(BannerAdPluginEvents.SizeChanged, () => {
        // Subscribe Change Banner Size
      });

      const options = {
        adId: process.env.VUE_APP_ADMOB_BANNER_KEY,
        adSize: BannerAdSize.BANNER,
        position: BannerAdPosition.BOTTOM_CENTER,
        margin: 0,
        isTesting: false,
        npa: true
      };
      AdMob.showBanner(options);
      AdMob.addListener("bannerAdLoaded", () => {
        this.BannerAdLoaded = true;
      });
    }
    },
    async initAdmob() {
      const { status } = await AdMob.trackingAuthorizationStatus();
      if (status === "notDetermined") {
        /**
         * If you want to explain TrackingAuthorization before showing the iOS dialog,
         * you can show the modal here.
         * ex)
         * const modal = await this.modalCtrl.create({
         *   component: RequestTrackingPage,
         * });
         * await modal.present();
         * await modal.onDidDismiss();  // Wait for close modal
         **/
      }
      AdMob.initialize({
        requestTrackingAuthorization: true,
        testingDevices: ["56C708F727ABCFCBEF6559F50CAB1A71"],
        initializeForTesting: true
        ,
      });
    },
    async setPrimaryLanguages() {
      if(this.languages.length>5 && !this.premium){
        this.templateLimitExceed=true
        this.primaryDialog=false
      }else{
          const a = this.$refs.primary.validate();

      if (a) {
        this.$store.commit("togglePrimaryDialog", false);
        await db
          .ref("users")
          .child(this.user.uid)
          .child("languages")
          .set(this.languages);

        this.$store.commit("setPrimaryLanguages", this.languages);
      }

      }
    
    },
  },
  async mounted() {
       setTimeout(()=>{
        SplashScreen.hide({fadeOutDuration: 150});
      }, 1000)
        var connectedRef = db.ref(".info/connected");
    connectedRef.on("value", (snap) => {
      if (snap.val() === true) {
        this.setOnlineStatus(true)
      } else {
        this.setOnlineStatus(false)
      }
    });
        if(this.user){
 const uid = this.user.uid;
        await this.$rtdbBind(
          "subscription",
          db
            .ref("users")
            .child(uid)
            .child("subscription")
        );
        }
        this.languages=this.languages1;
    if (!this.$store.getters.getCurrentLang) {
      const browserLang = navigator.languages
        ? navigator.languages[0]
        : navigator.language || navigator.userLanguage;
      this.$store.commit("setCurrentLang", browserLang);
    }
    await this.$store.dispatch("allLanguages");
    this.languageList = this.$store.getters.getAllLanguages;
     if (platform === "android") {
       if(!this.premium){
          this.initAdmob();
       }
        this.initAnalytics();
      }
      if(platform==='web'){
         let checkout = document.createElement('script')
         checkout.setAttribute('src', 'https://checkout.razorpay.com/v1/checkout.js')
         document.head.appendChild(checkout)
      }
  },
};
</script>

<style>
.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content {
  top: 68px !important;
}
</style>
